export interface StockReport {
  productID: number;
  productName: string;
  optionName?: string;
  quantity: number;
  inStock: boolean;
  isActive: boolean;
}

export const stockReportFromResponse = (responseData: any): StockReport => ({
  productID: responseData.product_id,
  productName: responseData.product_name,
  optionName: responseData.option_name,
  quantity: responseData.quantity,
  inStock: responseData.in_stock,
  isActive: responseData.is_active,
});
